import { createSelector } from 'reselect';
/* eslint-disable import/prefer-default-export */
import { getPageData } from '../reducers/pdp/selectors';

export const getSingleSampleSampleSku = createSelector(
  getPageData,
  pageData => pageData.singleSampleSku
);

export const getMultiSampleState = state => state.cards.cardCatalog.multiSampleState;



// WEBPACK FOOTER //
// ./src/cards/selectors/singlesample.js